export const QUEUES = [
  {
    ID: 1,
    NAME: 'ALL'
    // DESC: 'ALL'
  },
  {
    ID: 2,
    NAME: 'MY ASSIGNMENTS'
  },
  {
    ID: 3,
    NAME: 'APPEAL NOT STARTED'
  },
  {
    ID: 4,
    NAME: 'REVIEW IN PROCESS'
  },
  {
    ID: 5,
    NAME: 'PENDING ADDITIONAL INFORMATION'
  },
  {
    ID: 6,
    NAME: 'APPEAL SUPPORTED'
  },
  {
    ID: 7,
    NAME: 'APPEAL NOT SUPPORTED'
  },
  {
    ID: 8,
    NAME: 'NEXT FOLLOW UP DATE'
  },
  {
    ID: 9,
    NAME: 'FOLLOW UP OVERDUE'
  },
  // {
  // 	ID: 10,
  // 	NAME: 'CLOSED INTERNALLY'
  // },
  // {
  // 	ID: 11,
  // 	NAME: 'CLOSED CLIENT REQUEST'
  // },
  {
    ID: 12,
    NAME: 'OVERTURNED'
  },
  {
    ID: 13,
    NAME: 'UPHELD'
  },
  {
    ID: 14,
    NAME: 'CLOSED'
  }
]

export const APPEAL_LEVELS = {
  FIRST_LEVEL_LOCC: 1,
  SECOND_LEVEL_LOCC: 2,
  THIRD_LEVEL_LOCC: 3,
  FOURTH_LEVEL_LOCC: 4,
  INITIAL_RD: 5,
  SECOND_LEVEL_RD: 6,
  THIRD_LEVEL_RD: 7
}

export const DENIAL_TRACKING_STATUSES = {
  IN_PROGRESS: 1,
  COMPLETED: 2
}

export const ACCOUNT_STATUSES = {
  APPEAL_REVIEW: 1,
  CLOSED_INTERNALLY: 2,
  CLOSED_CLIENT_REQUEST: 3,
  APPEAL_NOT_STARTED: 4
}

export const DENIAL_APPEAL_STATUSES = {
  REVIEW_IN_PROCESS: 1,
  PENDING_ADDITIONAL_INFORMATION: 2,
  APPEAL_SUPPORTED: 3,
  APPEAL_NOT_SUPPORTED: 4
}

export const FEATURE_NAME = {
  CORTEX_UR_LINK: 'Admission.Header.cortexURLink',
  CLOSED_QUEUE_FILTER: 'Queue.ClosedQueueFilter'
}

export const LAST_ACTION = {
  CLOSED: 'closed',
  UPHELD_CLOSED: 'upheld,closed'
}
